var React = require('react');

function InfoIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.152 27.008c-.032-.384-.064-.704-.16-1.056H18.56V10.464h-7.552c-.128.64-.224 1.312-.224 1.984 0 .32.032.672.064 1.024s.096.704.16 1.024h2.464v11.456h-2.464l-.16 1.056-.064 1.024c0 .672.096 1.312.224 1.984h9.984c.16-.672.224-1.312.224-1.984 0-.32 0-.672-.064-1.024zM14.048 7.36l1.312.032 1.344-.032c.48 0 .928-.064 1.344-.128.064-.416.096-.864.128-1.28s.032-.832.032-1.216l-.032-1.248-.128-1.28-1.376-.16-1.344-.032-1.312.032c-.48.032-.896.096-1.312.16a14.24 14.24 0 0 0-.224 2.528c0 .8.064 1.632.224 2.496.416.064.864.128 1.344.128z"}));
}

InfoIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = InfoIcon;

InfoIcon.default = InfoIcon;
